import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { StepStatus } from './interfaces.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import ParagraphLg from '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Wrapper = styled.div(({ vertical }) => css `
    ${!vertical &&
    css `
      width: 100%;
    `}
    ${margins}
  `);
const StepsList = styled.ul(({ vertical }) => css `
    list-style: none;
    width: 100%;
    display: flex;
    justify-content: space-between;

    ${vertical &&
    css `
      height: 100%;
      flex-direction: column;
    `}
  `);
const StepsListItem = styled.li(({ theme: { olist: { components: { steps }, }, }, vertical, status, etcDone, }) => css `
    position: relative;
    display: flex;

    ${vertical
    ? css `
          align-items: flex-start;
        `
    : css `
          display: flex;
          align-items: center;
        `}

    &:not(:last-child) {
      flex-grow: 1;

      ${vertical &&
    css `
        min-height: 56px;
      `}

      &:after {
        content: '';
        position: absolute;
        background-color: ${status === StepStatus.done || etcDone
    ? steps.line.done['background-color']
    : steps.line.todo['background-color']};
        z-index: -1;

        ${vertical
    ? css `
              width: 1px;
              height: 100%;
              left: 20px;
              top: 0;
            `
    : css `
              width: 100%;
              right: 0;
              height: 1px;
            `}
      }
    }
  `);
const StepsListWrapperItems = styled.div(({ theme: { olist, olist: { components: { steps }, }, }, vertical, status, etcDone, }) => css `
    display: flex;
    width: fit-content;
    align-items: center;

    ${status === StepStatus.active &&
    css `
      background-color: ${steps.active['background-color']};
      border-radius: ${steps.active['border-radius']};

      ${ParagraphLg} {
        color: ${steps.active.color};
      }

      ${Bullet} {
        background-color: ${steps.active.bullet.color};
        border-color: ${steps.active.bullet.color};
      }
    `}

    ${status === StepStatus.todo &&
    !etcDone &&
    css `
      ${ParagraphLg} {
        opacity: ${steps.todo.opacity};
      }

      ${Bullet} {
        ${ParagraphLg}, svg {
          opacity: ${steps.todo.opacity};
        }
      }
    `}


    ${!vertical &&
    css `
      > ${ParagraphLg} {
        display: none;
      }
    `}

    @media (min-width: ${olist.breakpoints.small}) {
      > ${ParagraphLg} {
        display: block;
      }
    }

    > ${ParagraphLg} {
      padding-left: ${steps['wrapper-items'].padding.left};
      padding-right: ${steps['wrapper-items'].padding.right};
    }

    ${(status === StepStatus.done || etcDone) &&
    css `
      ${Bullet} {
        border-color: ${steps.done.bullet.color};
        svg {
          color: ${steps.done.bullet.color};
        }
      }
    `}
  `);
const Bullet = styled.span(({ theme: { olist: { components: { steps }, }, }, }) => css `
    width: 40px;
    height: 40px;

    display: flex;
    align-items: center;
    justify-content: center;

    box-sizing: border-box;

    background-color: ${steps.bullet['background-color']};

    border-radius: ${steps.bullet['border-radius']};
    border: 1px solid;
    border-color: ${steps.bullet['border-color']};
  `);
const AccessibilityStep = styled.span `
  opacity: 0;
  position: absolute;
`;

export { AccessibilityStep, Bullet, StepsList, StepsListItem, StepsListWrapperItems, Wrapper };
